if (!customElements.get('sibling-thumbnail')) {
  class SiblingThumbnail extends HTMLElement {
    static requests = new Map();
    static queue = [];
    static active = 0;

    static getThumbnail(url) {
      if (!this.requests.has(url)) {
        this.requests.set(url, new Promise((resolve) => {
          this.queue.push({ url, resolve });
          this.drain();
        }));
      }
      return this.requests.get(url);
    }

    static drain() {
      while (this.active < 4 && this.queue.length) {
        const { url, resolve } = this.queue.shift();
        this.active += 1;
        fetch(url, { credentials: 'same-origin', signal: AbortSignal.timeout(8000) })
          .then((response) => response.ok && !response.redirected ? response.json() : null)
          .then((data) => resolve(data && typeof data.image === 'string' ? data.image : ''))
          .catch(() => resolve(''))
          .finally(() => {
            this.active -= 1;
            this.drain();
          });
      }
    }

    connectedCallback() {
      if (!this.hasAttribute('data-load-thumbnail') || this.started) return;
      this.frame = requestAnimationFrame(() => {
        const link = this.closest('a');
        if (!link) return;
        this.observer = new IntersectionObserver((entries) => {
          if (entries.some((entry) => entry.isIntersecting)) {
            this.observer.disconnect();
            this.started = true;
            this.loadThumbnail(link);
          }
        }, { rootMargin: '200px' });
        this.observer.observe(link);
      });
    }

    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      this.observer?.disconnect();
      this.started = false;
    }

    async loadThumbnail(link) {
      const url = new URL(link.href, window.location.origin);
      if (url.origin !== window.location.origin) return;
      url.search = '';
      url.hash = '';
      url.searchParams.set('view', 'sibling-thumbnail');
      const preview = new URLSearchParams(window.location.search).get('preview_theme_id');
      if (preview) url.searchParams.set('preview_theme_id', preview);
      const source = await SiblingThumbnail.getThumbnail(url.href);
      if (!source || !this.isConnected) return;
      let imageUrl;
      try {
        imageUrl = new URL(source, window.location.origin);
      } catch {
        return;
      }
      if (!['http:', 'https:'].includes(imageUrl.protocol)) return;
      const loadedImage = new Image();
      loadedImage.src = imageUrl.href;
      try {
        await loadedImage.decode();
      } catch {
        return;
      }
      if (!this.isConnected) return;
      const previousImage = this.querySelector('img');
      loadedImage.alt = previousImage?.alt || this.dataset.title || '';
      loadedImage.className = previousImage?.className || '';
      loadedImage.classList.add('sibling-thumbnail--custom');
      loadedImage.width = 80;
      loadedImage.height = 100;
      this.replaceChildren(loadedImage);
    }
  }
  customElements.define('sibling-thumbnail', SiblingThumbnail);
}
